import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getLatestNews } from "../../services/newsServices";
import Button from "../../components/Button/Button";
import { useUser } from "../Home/UserContext";

const LatestNews = () => {
  const [newsList, setNewsList] = useState([]);
  const [selectedNews, setSelectedNews] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const navigate = useNavigate();
  const { user } = useUser();

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const latestNews = await getLatestNews();
        const activeNews = latestNews.filter((news) => news.is_active);
        setNewsList(activeNews.slice(0, 3));
      } catch (error) {
        console.error("Failed to fetch news", error);
      }
    };

    fetchNews();
  }, []);

  const handleReadMore = (news) => {
    setSelectedNews(news);
  };

  const closeNewsModal = () => {
    setSelectedNews(null);
  };

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="container mx-auto">
      <h2 className="text-3xl font-extrabold mb-4 text-primary mx-auto text-center font-satoshi uppercase">
        Dernières Actualités
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
        {newsList.map((news) => (
          <div
            key={news.id}
            className="flex flex-col bg-slate-100 dark:bg-slate-500 shadow-md rounded-lg p-4 justify-between h-full"
          >
            <div>
              {/* Image qui ouvre une modale au clic */}
              <img
                src={news.image_url || "/img/no-image.jpg"}
                alt={news.title || "Image non disponible"}
                className="w-full h-64 object-cover rounded-t-lg cursor-pointer"
                onClick={() =>
                  openImageModal(news.image_url || "/img/no-image.jpg")
                }
              />
              <h3 className="text-xl font-bold mb-2 mt-2">{news.title}</h3>
              <h5 className="text-xs mb-3 text-black bg-gray-200 p-2">
                {news.author?.prenom} {news.author?.nom}
              </h5>

              {/* Texte limité à 5-6 lignes */}
              <div className="text-sm text-gray-600 dark:text-slate-300 mb-4 line-clamp-6">
                <div dangerouslySetInnerHTML={{ __html: news.content }} />
              </div>

              {/* Bouton "Suite ..." */}
              <button
                onClick={() => handleReadMore(news)}
                className="text-blue-500 hover:underline text-sm font-semibold"
              >
                Suite ...
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modale pour afficher l'article complet */}
      {selectedNews && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-slate-700 rounded-lg shadow-lg max-w-4xl w-full flex overflow-hidden">
            {/* Image toujours présente dans la modale */}
            <div className="w-1/3">
              <img
                src={selectedNews.image_url || "/img/no-image.jpg"}
                alt="Agrandissement"
                className="w-full h-full object-cover rounded-l-lg"
              />
            </div>

            {/* Contenu à droite */}
            <div className="w-2/3 flex flex-col p-6 relative">
              <h2 className="text-xl font-bold mb-2">{selectedNews.title}</h2>
              <h5 className="text-xs mb-3 text-black bg-gray-200 p-2">
                {selectedNews.author?.prenom} {selectedNews.author?.nom}
              </h5>

              {/* Contenu avec scroll vertical */}
              <div className="overflow-y-auto max-h-80 pr-2">
                <div
                  className="text-sm text-gray-700 dark:text-gray-300"
                  dangerouslySetInnerHTML={{ __html: selectedNews.content }}
                />
              </div>

              {/* Bouton pour fermer la modale */}
              <button
                className="absolute top-2 right-2 text-gray-600 dark:text-gray-300 text-2xl"
                onClick={closeNewsModal}
                aria-label="Fermer"
              >
                &times;
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modale pour agrandir l'image seule */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={closeImageModal}
        >
          <div className="relative">
            <img
              src={selectedImage}
              alt="Agrandissement"
              className="max-w-full max-h-[70vh] rounded-lg"
            />
            <button
              className="absolute top-2 right-2 text-white text-2xl"
              onClick={closeImageModal}
              aria-label="Fermer"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LatestNews;
